module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/main-menu/main-menu.component.scss
// module id = ./src/app/components/framework/main-menu/main-menu.component.scss
// module chunks = main